export enum SearchParamOperator {
    EQUALS = 'EQUALS',
    LIKE = 'LIKE',
    IN = 'IN'
}